import { PageList } from "../../components/pageList.js";
import React from "react";

import ActionCellRender from "../../components/actionCellRender.js";
import { IconPencil, IconTrash, IconSettings } from "@tabler/icons";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList.js";
import { useCellRender } from "../../hooks/useCellRender.js";
import FileList from "../../components/fileList.js";
import ActivityLog from "../../components/activityLog.js";
import RemoteSelect2 from "../../components/remoteSelect2.js";
import _ from "lodash";

import {
  Select,
  Checkbox,
  TextInput,
  Text,
  Switch,
  Textarea,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import moment from "moment";
import AutoCodeInput from "../../components/autoCodeInput.js";
import FormConfirmation from "../../components/formConfirmation.js";
import GIMatchingTable from "../../components/giMatchingTable";
import GIMatchingPaymentStats from "../../components/giMatchingPaymentStat";

const apiEntity = "giMatchPayment";

const initialValues = {
  consultants: [],
  date: moment().toISOString(),

  status: "PENDING",
};

export const addFormSchema = {
  name: "debitNoteSchema",
  title: "New GI Match Payment",
  description: "Please follow the step to create a New Debit Note",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
  },
  apiEntity,
  showSaveBar: false,

  initialValues,
  validate: {},

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,
        props: {
          variant: "default", //default | pills | outline
          defaultValue: "Basic Info",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          {
            key: "t1-1",
            label: "Basic Info",
            icon: IconSettings,
          },
          // { key: "t1-2", label: "Import Data", icon: IconSettings },

          { key: "t1-3", label: "Confirm", icon: IconSettings },
        ],
      },
      {
        key: "section-info",
        parent: "t1-1",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          // title: "Payroll Info",
          description: "Please fill in the basic information of the matching",
          withBorder: false,
          withPaper: false,
          ml: 0,
          mt: 0,
          p: 0,
        },
      },

      {
        key: "section-confirm",
        parent: "t1-3",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          description: "Please confirm the statement details",
          withBorder: false,
          withPaper: false,
          ml: 0,
          mt: 0,
          p: 0,
        },
      },
    ],

    fields: [
      {
        name: "code",
        component: AutoCodeInput,
        parent: "section-info",
        props: {
          required: true,
          placeholder: "PR-202212",
          label: "Patch ID",
        },
      },

      {
        name: "importRemark",
        component: Textarea,
        parent: "section-info",
        props: {
          placeholder: "",
          label: "Remark",
        },
      },
      {
        name: "confirm",
        component: FormConfirmation,
        parent: "section-confirm",
        props: {
          successText: [
            "Please confirm if to create the new payment matching.",
          ],
        },
      },

      // {
      //     name: "rows",
      //     component: PayrollImporter,
      //     parent: "section-import",
      //     props: {},
      // },
    ],
  },
};

const MatchPayment = ({}) => {
  const [cellRender] = useCellRender();

  const tableSchema = {
    showActionColumn: true,
    columns: [
      {
        field: "code",
        headerName: "DN No.",
        sortable: true,
        cellRender: (col, data) => cellRender.DebitNoteCode(data),
      },
      {
        field: "createdAT",
        headerName: "Date",
        sortable: true,
        cellRender: (col, data) => moment(data.createdAt).format("LL"),
      },
      {
        field: "numOfMatchings",
        headerName: "Number of Payments",
        sortable: true,
      },

      {
        field: "status",
        headerName: "Status",
        sortable: true,
        cellRender: (col, data) => (
          <>{data.status ? cellRender.Status(data.status) : ""}</>
        ),
      },
      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
      },
    ],
  };

  const editFormSchema = {
    title: "GI Match Payment",
    titleField: "code",
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
      size: "xl", //xs, sm, xl  ....100%
      // position:"right"
    },
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "main-tab",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Matching Payments",
          },
          tab: [
            {
              key: "tab1",
              label: "Matching Payments",
              icon: IconSettings,
            },

            {
              key: "tab2",
              label: "Files",
              icon: IconSettings,
            },

            {
              key: "tab3",
              label: "Logs",
              icon: IconSettings,
            },
          ],
        },
        {
          key: "section-files",
          parent: "tab2",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Files",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-matchings",
          parent: "tab1",
          type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
          props: {
            mt: 50,
          },
        },

        {
          key: "section-log",
          parent: "tab3",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Activity Log",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
      ],

      fields: [
        {
          name: "payrollStat",
          parent: "section-matchings",
          component: GIMatchingPaymentStats,
          props: {
            cols: 3,
          },
        },
        {
          name: "matchings",
          parent: "section-matchings",
          component: GIMatchingTable,
          props: {},
        },

        {
          name: "files",
          component: FileList,
          parent: "section-files",
          props: {},
        },

        {
          name: "logs",
          component: ActivityLog,
          parent: "section-log",
          props: {},
        },
      ],
    },
  };

  const formSchema = {
    add: addFormSchema,
    edit: editFormSchema,
  };

  return (
    <PageList
      title={"GI Match Payment"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
      searchByTextField={true}
    />
  );
};

export default MatchPayment;
